export const environment = {
  production: false,
  siteUrl: '/',  
  apiUrl: 'https://qld-uat-api.classcover.com.au/',
  client_id: 'KSnEzMXWSMK2V2c8GPiaE8ezpdz3We1HQu8akMJT',
  client_secret: 'z8ywJrIlEg7leIy3xWnuuouqRGnmRVh2riHmPpwAwMxk1ydJJkRFOLt9a9KIWLUxPdzSKEgm5yS4Lbfv7WWknZlliHKcXNlk9no15utdBhM9rXGMz1jP7LxfpG6py4wU',
  INTERCOM_ID: 'f9jb6j9y',
  backToAdmin: 'https://qld-uat-api.classcover.com.au/admin/',
  backToCoOrdinator: 'https://qld-uat-api.classcover.com.au/en/back_to_admin',
  backToGroup: 'https://qld-uat-api.classcover.com.au/en/back_to_admin',
  cookiesDomain: 'classcover.com.au',
  locationURL: 'https://qld-uat.classcover.com.au/',
};